import { APP_BASE_HREF } from '@angular/common';
import { FactoryProvider } from '@angular/core';

export const BaseHrefProvider: FactoryProvider = {
  provide: APP_BASE_HREF,
  useFactory: (): string => {
    const parts: string [] = [
      window.location.origin,
      window.location.pathname,
      window.location.search,
      '#',
    ];

    return parts.join('');
  },
};
